(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ayuda-hub"]) return;
  try {
    
(function () {
  var root = document.getElementById('ayuda-hub-root');
  if (!root) return;
  var dataEl = document.getElementById('ayuda-hub-kb');
  if (!dataEl) return;
  var KB = JSON.parse(dataEl.textContent);
  var topics = KB.topics || {};
  var view = document.getElementById('ah-view');

  var stack = [{ node: { label: 'Inicio', children: KB.menu }, label: 'Inicio' }];
  var order = null, orderInput = '', emailInput = '', postalInput = '', orderData = null;
  var API_BASE = '/apps/ayuda';  // App Proxy → backend SuplAI (Shopify firma la petición)
  var formCtx = null;  // {label, topicId, kind, incidentType} en modo formulario; {success:true} tras enviar
  var INCIDENT_TYPE_BY_TOPIC = {
    product_broken: 'broken', product_expired: 'expired', wrong_product: 'wrong',
    missing_item: 'missing', missing_parcel: 'missing', product_warranty: 'broken'
  };
  // Variantes del formulario por topic (correcciones ATC 2026-07-30).
  //   noOrder: no pedimos nº de pedido (aún no existe o no aplica) → va a
  //     /escalation sin order_name (el backend lo acepta y etiqueta sin_pedido).
  //   askName: pedimos el nombre para que el agente sepa a quién responde.
  //   photoLabel: adjunto propio del flujo (captura, justificante, documento).
  //   photoRequired: el adjunto es un requisito del flujo (verificación de
  //     identidad en baja de cuenta / cambio de email). Si la SUBIDA falla en
  //     el momento del envío, la consulta se manda igual (nunca bloqueamos) y
  //     el agente lo re-solicita.
  // reasons: desplegable de motivo — viaja como primera línea del mensaje para
  // que el agente lo vea mascado sin leer texto libre.
  // reasonLabel: rótulo del desplegable (default "Motivo").
  // msgPlaceholder: placeholder-ejemplo del textarea que ENSEÑA qué información
  //   es útil (corrección ATC 07/08).
  // minMsg: mínimo de caracteres del mensaje; por debajo bloqueamos con un
  //   error amable para que el agente no tenga que volver a preguntar.
  var FORM_VARIANTS = {
    purchase_failure: {
      noOrder: true, askName: true,
      reasons: ['No me deja finalizar el pago', 'Error al aplicar un descuento o saldo', 'La web da error / se queda cargando', 'Otro problema'],
      photoLabel: 'Captura del error (opcional, nos ayuda a resolverlo antes)'
    },
    duplicate_payment: {
      noOrder: true, askName: true,
      photoLabel: 'Justificante del pago duplicado (opcional)'
    },
    account_delete: {
      noOrder: true, askName: true, photoRequired: true,
      reasons: ['Ya no uso la cuenta', 'Recibo demasiadas comunicaciones', 'Preocupación por mis datos (RGPD)', 'Otro motivo'],
      photoLabel: 'Documento de verificación (p. ej. DNI — tapa todos los datos salvo tu nombre)'
    },
    account_change_email: {
      noOrder: true, askName: true, photoRequired: true,
      photoLabel: 'Documento de verificación (p. ej. DNI — tapa todos los datos salvo tu nombre)'
    },
    // Factura a nombre de empresa. Es el ÚNICO flujo del hub que no acaba en
    // texto libre: `/invoice-request` crea el ticket de helpdesk en Odoo con
    // los datos fiscales ya estructurados campo a campo. Hasta ahora el topic
    // era un enlace a /account y el cliente acababa escribiendo sus datos
    // fiscales en un correo, que es la parte que el agente tiene que teclear.
    invoice_company: {
      fiscalFields: true, askName: true,
      msgLabel: 'Observaciones (opcional)',
      msgPlaceholder: 'Cualquier cosa que debamos tener en cuenta para emitir la factura.',
      msgOptional: true
    },
    free_text_escalation: {
      reasonLabel: '¿Qué tipo de consulta es?',
      reasons: ['Sobre mi pedido', 'Sobre un producto', 'Facturas y pagos', 'Mi cuenta', 'Otro tema'],
      msgPlaceholder: 'Ej.: Intenté aplicar un código de descuento en el pago y me dio un error. Pasó hoy sobre las 18:00, usando Chrome en el móvil.',
      minMsg: 20
    }
  };
  // Campos fiscales de la factura a empresa → InvoiceRequest del backend.
  // `key` es el nombre EXACTO del campo en el schema: cambiarlo aquí sin
  // cambiarlo allí manda el dato al limbo sin error (el backend ignora extras).
  var FISCAL_FIELDS = [
    { id: 'ah-f-razon', key: 'razon_social', label: 'Razón social', ph: 'Nombre fiscal de la empresa', autocomplete: 'organization', required: true },
    { id: 'ah-f-nif', key: 'nif_cif', label: 'NIF / CIF', ph: 'B12345678', required: true },
    { id: 'ah-f-faddr', key: 'fiscal_address', label: 'Dirección fiscal', ph: 'Calle y número', autocomplete: 'street-address', required: true },
    { id: 'ah-f-fcp', key: 'fiscal_postal_code', label: 'Código postal fiscal', ph: '28001', required: true },
    { id: 'ah-f-fcity', key: 'fiscal_city', label: 'Localidad', ph: 'Madrid', autocomplete: 'address-level2', required: true },
    { id: 'ah-f-fprov', key: 'fiscal_province', label: 'Provincia', ph: 'Madrid', autocomplete: 'address-level1', required: true }
  ];
  // Topics inform/self-service que además ofrecen abrir ticket con un agente
  // (cancelar/modificar si ya está expedido; no-recibido si hay demora).
  var EXTRA_AGENT_TOPICS = ['order_cancel', 'order_modify', 'order_not_arrived'];
  // Topics con botón de seguimiento en vivo cuando conocemos el tracking real.
  var TRACKING_TOPICS = ['order_not_arrived', 'order_delivery_attempt_absent'];
  // Topics de entrega donde, además del seguimiento, ofrecemos GESTIONAR con la
  // agencia. Medido sobre 1.441 tickets de entrega de ago-sep 2026: el 33% ya
  // traía el nº de seguimiento en la mano y el 62,8% pedía que actuáramos, así
  // que repetirle el enlace de tracking no le resuelve nada. Lo que sí puede
  // hacer él mismo —cambiar la dirección, dar una franja, autorizar la entrega,
  // recoger en un punto— se hace en la web de SU agencia, y hasta ahora eso
  // estaba enterrado en un artículo del centro de ayuda valorado 12% útil.
  var CARRIER_TOPICS = ['order_not_arrived', 'order_delivery_attempt_absent',
    'order_delivered_not_received', 'order_change_delivery', 'order_tracking', 'order_status'];
  // Enlaces oficiales por agencia (artículo FD 103000381293, verificado 11-09-2026).
  // La clave se compara en minúsculas y por inclusión: Shopify devuelve el
  // nombre del transportista con grafías distintas ("DHL Parcel", "Correos Express").
  var CARRIERS = [
    { match: ['dhl'], name: 'DHL',
      manage: 'https://www.dhl.com/es-es/ecommerce/home.html',
      contact: 'https://www.dhl.com/es-es/ecommerce/home/private-shipments/contact.html',
      phone: '91 919 92 24' },
    { match: ['correos'], name: 'Correos',
      manage: 'https://www.correos.es/es/es/particulares/recibir/esperando-la-entrega/quiero-modificar-la-entrega',
      contact: 'https://www.correos.es/es/es/herramientas/localizador/envios',
      phone: '915 197 197' },
    { match: ['paack'], name: 'PAACK',
      manage: 'https://help.paack.co/es/support/home',
      contact: 'https://help.paack.co/es/support/home',
      phone: '93 122 38 51' },
    { match: ['gls'], name: 'GLS',
      manage: 'https://gls-group.com/ES/es/parcel-shops/',
      contact: 'https://gls-group.com/ES/es/contacto/',
      phone: null },
    { match: ['inpost'], name: 'InPost',
      manage: 'https://www.inpost.es/seguimiento-del-envio/',
      contact: 'https://www.inpost.es/',
      phone: '900 900 137' },
    { match: ['mrw'], name: 'MRW',
      manage: 'https://www.mrw.es/seguimiento/envio.asp',
      contact: 'https://www.mrw.es/seguimiento/envio.asp',
      phone: null }
  ];
  function carrierFor(name) {
    var n = (name || '').toLowerCase();
    if (!n) return null;
    for (var i = 0; i < CARRIERS.length; i++) {
      for (var j = 0; j < CARRIERS[i].match.length; j++) {
        if (n.indexOf(CARRIERS[i].match[j]) >= 0) return CARRIERS[i];
      }
    }
    return null;
  }
  // Topics con consulta interactiva en vivo (App Proxy → backend SuplAI).
  // Si el backend no está disponible, el panel degrada sin bloquear la respuesta estática.
  // Nunca pedimos SKU (el cliente no lo conoce): siempre el NOMBRE del
  // artículo, copiado tal cual de la web. Caducidad y disponibilidad se
  // resuelven primero EN CLIENTE con datos ya públicos (búsqueda predictiva
  // + plantilla product.caducidad — el mismo metafield que pinta la ficha),
  // y el backend queda como fallback de enriquecimiento (ETA, FEFO Odoo).
  var PRODUCT_TOOL = {
    product_info: {
      endpoint: '/product-question', mode: 'question',
      title: 'Pregúntanos sobre un producto',
      prodLabel: 'Nombre del artículo',
      prodHint: 'Copia y pega el nombre exacto del artículo, tal y como aparece en la web.',
      qLabel: '¿Qué quieres saber?', qHint: 'Ej.: ¿es apto para veganos?, ¿lleva gluten?, ¿qué ingredientes tiene?',
      btn: 'Consultar'
    },
    product_expiry_date: {
      endpoint: '/product-expiry', mode: 'lookup', storefront: 'expiry',
      title: 'Consulta la caducidad',
      prodLabel: 'Nombre del artículo',
      prodHint: 'Copia y pega el nombre exacto del artículo, tal y como aparece en la web.',
      btn: 'Ver caducidad'
    },
    product_availability: {
      endpoint: '/product-availability', mode: 'lookup', storefront: 'availability',
      title: 'Comprueba la disponibilidad',
      prodLabel: 'Nombre del artículo',
      prodHint: 'Copia y pega el nombre exacto del artículo, tal y como aparece en la web.',
      btn: 'Ver disponibilidad'
    }
  };

  // Iconos de línea (mismo set que la portada rediseñada; sustituyen a los emojis).
  function svgIcon(paths, size, sw) {
    return '<svg width="' + size + '" height="' + size + '" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="' +
      (sw || 1.7) + '" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' + paths + '</svg>';
  }
  var ICON_PATHS = {
    user: '<circle cx="12" cy="8" r="3.6"/><path d="M4.5 20a7.5 7.5 0 0 1 15 0"/>',
    cart: '<path d="M3 4h2.2l2.3 10.5h10.3L20 7H6"/><circle cx="9.5" cy="19" r="1.6"/><circle cx="17" cy="19" r="1.6"/>',
    box: '<path d="M12 3 20.5 7.5v9L12 21 3.5 16.5v-9z"/><path d="M3.5 7.5 12 12l8.5-4.5"/><line x1="12" y1="12" x2="12" y2="21"/>',
    leaf: '<path d="M12 21c0-6 3.5-9.5 8-10-.5 6-4 9.5-8 10z"/><path d="M12 21C12 15 8.5 11.5 4 11c.5 6 4 9.5 8 10z"/><line x1="12" y1="21" x2="12" y2="14"/>',
    chat: '<path d="M4 5h16v11H9l-5 4z"/><circle cx="9" cy="10.5" r=".9" fill="currentColor" stroke="none"/><circle cx="12" cy="10.5" r=".9" fill="currentColor" stroke="none"/><circle cx="15" cy="10.5" r=".9" fill="currentColor" stroke="none"/>',
    truck: '<path d="M3 7h11v9H3z"/><path d="M14 10h4l3 3v3h-7z"/><circle cx="7" cy="18" r="1.8"/><circle cx="17" cy="18" r="1.8"/>',
    ret: '<path d="M4 9h11a5 5 0 0 1 0 10H8"/><path d="M8 5 4 9l4 4"/>',
    invoice: '<path d="M6 3h9l4 4v14H6z"/><line x1="9" y1="11" x2="16" y2="11"/><line x1="9" y1="15" x2="14" y2="15"/>',
    search: '<circle cx="11" cy="11" r="7"/><line x1="16.5" y1="16.5" x2="21" y2="21"/>',
    card: '<rect x="2.5" y="5" width="19" height="14" rx="2.5"/><line x1="2.5" y1="10" x2="21.5" y2="10"/><line x1="6" y1="14.5" x2="10" y2="14.5"/>',
    chev: '<path d="M9 5l7 7-7 7"/>',
    chevDown: '<path d="M6 9l6 6 6-6"/>',
    help: '<circle cx="12" cy="12" r="9"/><path d="M9.5 9.2a2.6 2.6 0 0 1 3.8 2.2c0 1.6-2 1.9-2 3.1"/><line x1="12.3" y1="17.3" x2="12.3" y2="17.31"/>'
  };
  // Mapa key de tema → icono de línea.
  var GLYPHS = { A: 'user', B: 'cart', C: 'box', D: 'leaf', E: 'card', F: 'chat' };
  // Descripción de una línea para las tarjetas de la portada (nivel 1).
  var TOPIC_DESC = {
    A: 'Acceso, datos personales, baja y favoritos.',
    B: 'Plazos, gastos de envío, zonas y puntos de recogida.',
    C: 'Estado del envío, cambios, incidencias, devoluciones y facturas.',
    D: 'Composición, caducidad, disponibilidad y stock.',
    E: 'Formas de pago, cupones, cashback y saldo en tienda.',
    F: 'Marketplace, venta a empresas y cualquier otra consulta.'
  };
  var CHANNEL = {
    inform: { cls: 'inform', label: 'Respuesta inmediata' },
    self_service_portal: { cls: 'portal', label: 'Lo gestionas tú' },
    human_action: { cls: 'human', label: 'Te ayuda un agente' }
  };
  var INPUT_LABELS = {
    order_id: 'Nº de pedido', photo: 'Foto', item_selection: 'Producto(s)', reason: 'Motivo',
    refund_preference: 'Reembolso: saldo o pago', new_shipping_address: 'Nueva dirección',
    fiscal_data: 'Datos fiscales', free_text: 'Tu mensaje'
  };

  function esc(s) { var d = document.createElement('div'); d.textContent = s == null ? '' : s; return d.innerHTML; }

  function statusEs(d) {
    var f = ((d && d.display_fulfillment_status) || '').toUpperCase();
    var map = { FULFILLED: 'enviado', UNFULFILLED: 'en preparación', PARTIALLY_FULFILLED: 'enviado parcialmente',
      IN_PROGRESS: 'en preparación', ON_HOLD: 'en espera', SCHEDULED: 'programado', DELIVERED: 'entregado', RESTOCKED: 'reingresado' };
    return map[f] || (d && d.display_fulfillment_status) || 'en preparación';
  }
  // Marca un fragmento HTML como de confianza (ya construido con esc() en sus
  // partes dinámicas), para que formatAnswer lo inserte tal cual sin escaparlo
  // de nuevo. Cualquier token que NO pase por aquí se trata como texto plano
  // y se escapa siempre, aunque en el futuro se le olvide a quien lo añada.
  function trustedHtml(s) { return { __html: s }; }
  // Rellena un [token] con dato REAL del pedido; null si no aplica.
  function resolveToken(tok) {
    if (!orderData) return null;
    var k = tok.toLowerCase();
    if (k.indexOf('estado') >= 0) return statusEs(orderData);
    if (k.indexOf('tracking') >= 0 || k.indexOf('seguimiento') >= 0)
      return orderData.tracking_url
        ? trustedHtml('<a class="ah-article" href="' + esc(orderData.tracking_url) + '" target="_blank" rel="noopener">consulta el seguimiento aquí ↗</a>')
        : 'todavía sin número de seguimiento';
    if (k.indexOf('saldo') >= 0)
      return (orderData.store_credit_balance != null) ? ('tu saldo actual es de ' + orderData.store_credit_balance + ' €') : null;
    if (k.indexOf('agencia') >= 0) return 'la agencia de transporte';
    return null;
  }
  // Sin datos del pedido: quitamos SOLO la frase que depende del token y
  // conservamos el resto del texto, que sigue siendo útil por sí mismo
  // (plazos, "lo tienes en Mis pedidos", etc.). El bloque `[^.!?]*` no puede
  // cruzar un punto, así que el match se ancla al inicio de la propia frase.
  function stripTokenSentences(text) {
    return text.split(/\n{2,}/).map(function (para) {
      return para.replace(/\n/g, ' ')
        .replace(/[^.!?]*\[[^\]]+\][^.!?]*[.!?]/g, '')
        .replace(/\s{2,}/g, ' ')
        .trim();
    }).filter(function (p) { return p; }).join('\n\n');
  }
  function formatAnswer(text) {
    var out = esc(text).replace(/\[([^\]]+)\]/g, function (_, t) {
      var v = resolveToken(t);
      // Token sin dato real → se omite (nunca se muestra el token en crudo).
      if (v == null) return '';
      var html = (v && typeof v === 'object' && v.__html != null) ? v.__html : esc(String(v));
      return '<strong>' + html + '</strong>';
    });
    return out.split(/\n{2,}/).map(function (p) { return '<p>' + p.replace(/\n/g, ' ') + '</p>'; }).join('');
  }

  // Navegación compartida (portada y submenús): empuja el nodo en la pila,
  // abriendo el gate de pedido cuando la rama lo requiere.
  // Portada (nivel 1): buscador + accesos rápidos + rejilla de temas + contacto,
  // con la estética de la nueva portada. Los temas navegan como siempre.
  // --- Buscador en vivo sobre la KB de esta página ---
  // Indexa cada tema-respuesta (hoja con `topic`) con su etiqueta, las
  // preguntas del cliente y el texto de la respuesta, y guarda la ruta (path)
  // para navegar directamente al resultado. Sin backend: todo es la KB embebida.
  function ahNorm(s) { return (s == null ? '' : String(s)).toLowerCase().replace(/[\u00e1\u00e0\u00e4\u00e2\u00e3]/g,'a').replace(/[\u00e9\u00e8\u00eb\u00ea]/g,'e').replace(/[\u00ed\u00ec\u00ef\u00ee]/g,'i').replace(/[\u00f3\u00f2\u00f6\u00f4\u00f5]/g,'o').replace(/[\u00fa\u00f9\u00fc\u00fb]/g,'u').replace(/\u00f1/g,'n').replace(/\u00e7/g,'c'); }
  var SEARCH_INDEX = null;
  function buildSearchIndex() {
    SEARCH_INDEX = [];
    (function walk(node, path) {
      (node.children || []).forEach(function (ch) {
        var entryPath = path.concat([{ node: ch, label: ch.label }]);
        if (ch.topic) {
          var t = topics[ch.topic] || {};
          var parts = [ch.label];
          if (t.customer_questions && t.customer_questions.length) parts = parts.concat(t.customer_questions);
          if (t.answer_template) parts.push(t.answer_template);
          var cats = path.slice(1).map(function (p) { return p.label; }); // sin el "Inicio" raíz
          SEARCH_INDEX.push({
            topic: ch.topic,
            label: ch.label,
            category: cats.join(' · '),
            path: entryPath,
            hay: ahNorm(parts.join('  ') + '  ' + cats.join(' '))
          });
        }
        if (ch.children) walk(ch, entryPath);
      });
    })({ children: KB.menu }, [stack[0]]);
  }
  var AH_STOP = { de:1, la:1, el:1, los:1, las:1, un:1, una:1, unos:1, unas:1, mi:1, mis:1, tu:1, tus:1,
    su:1, sus:1, con:1, que:1, y:1, o:1, u:1, a:1, en:1, para:1, por:1, del:1, al:1, me:1, se:1, lo:1,
    es:1, esta:1, este:1, como:1, cual:1, cuales:1 };
  function searchKB(query) {
    if (!SEARCH_INDEX) buildSearchIndex();
    var nq = ahNorm(query);
    var all = nq.split(/\s+/).filter(Boolean);
    // Palabras significativas (ignora conectores/stopwords). Si no queda ninguna
    // (consulta muy corta), usa todas para no dejar al cliente sin resultados.
    var toks = all.filter(function (t) { return t.length >= 3 && !AH_STOP[t]; });
    if (!toks.length) toks = all;
    if (!toks.length) return [];
    var scored = [];
    SEARCH_INDEX.forEach(function (e) {
      var lbl = ahNorm(e.label), hits = 0, score = 0;
      toks.forEach(function (tk) {
        if (e.hay.indexOf(tk) >= 0) { hits++; score += 1; if (lbl.indexOf(tk) >= 0) score += 3; }
      });
      if (!hits) return;                       // al menos una palabra debe aparecer
      if (lbl.indexOf(nq) >= 0) score += 8;     // el título contiene la frase entera
      scored.push({ e: e, hits: hits, score: score });
    });
    // Prioriza cobertura (nº de palabras encontradas) y luego relevancia.
    scored.sort(function (a, b) { return (b.hits - a.hits) || (b.score - a.score); });
    return scored.slice(0, 8).map(function (s) { return s.e; });
  }

  // Respuestas de las preguntas frecuentes, en HTML y por tema. Mandan sobre el
  // texto de la KB: son las revisadas por ATC y traen listas, enlaces y capturas.
  var FAQ_HTML = (function () {
    var out = {}, src = document.getElementById('ah-faq-src');
    if (src) {
      var nodes = src.querySelectorAll('[data-topic]');
      for (var i = 0; i < nodes.length; i++) out[nodes[i].getAttribute('data-topic')] = nodes[i].innerHTML;
    }
    return out;
  })();
  // Temas cuya respuesta depende de datos reales (estado del pedido, saldo): en
  // ellos ofrecemos identificar el pedido DENTRO de la propia respuesta. Hasta
  // ahora el gate era inalcanzable (ninguna hoja del árbol llevaba `requires`),
  // así que estos temas siempre acababan en "no hemos podido consultarlo".
  var LOOKUP_TOPICS = ['order_tracking', 'order_delivery_attempt_absent', 'use_balance'];
  var LOOKUP_DISMISSED = {};
  var QNODES = {};  // topic → {d: <details>, body: <div.ah-a>, node}

  function chevSvg() { return svgIcon(ICON_PATHS.chevDown, 16, 2.2); }

  // Cuerpo de una respuesta: texto (FAQ o KB) + lo interactivo del tema.
  function paintAnswer(node, body) {
    body.innerHTML = '';
    body.appendChild(renderAnswer(node, body));
    // El bloque de identificación va DEBAJO de la respuesta: primero se lee la
    // información general y luego, quien quiera su dato real, se identifica.
    if (LOOKUP_TOPICS.indexOf(node.topic) >= 0 && !order && !LOOKUP_DISMISSED[node.topic]) {
      var g = document.createElement('details');
      g.className = 'ah-lookup';
      var gs = document.createElement('summary');
      gs.innerHTML = (node.topic === 'use_balance'
        ? 'Consultar el saldo que tengo disponible'
        : 'Ver el estado real de mi pedido') +
        '<span class="ah-q-chev" aria-hidden="true">' + chevSvg() + '</span>';
      g.appendChild(gs);
      var gb = document.createElement('div');
      gb.className = 'ah-lookup-b';
      gb.appendChild(renderGate(node, function (on) {
        if (!on) LOOKUP_DISMISSED[node.topic] = true;
        paintAnswer(node, body);
      }));
      g.appendChild(gb);
      body.appendChild(g);
    }
  }

  function questionEl(node) {
    var d = document.createElement('details');
    d.className = 'ah-q';
    var sum = document.createElement('summary');
    sum.innerHTML = esc(node.label) + '<span class="ah-q-chev" aria-hidden="true">' + chevSvg() + '</span>';
    d.appendChild(sum);
    var body = document.createElement('div');
    body.className = 'ah-a';
    d.appendChild(body);
    // Perezoso: el cuerpo se construye la primera vez que se abre la pregunta.
    d.addEventListener('toggle', function () {
      if (d.open && !body.firstChild) paintAnswer(node, body);
    });
    if (node.topic) QNODES[node.topic] = { d: d, body: body, node: node };
    return d;
  }

  function renderAccordion(menu) {
    var wrap = document.createElement('div');
    wrap.className = 'ah-secs';
    (menu || []).forEach(function (group) {
      var sec = document.createElement('details');
      sec.className = 'ah-sec';
      var sum = document.createElement('summary');
      sum.className = 'ah-sec-t';
      var ico = (group.key && GLYPHS[group.key]) ? svgIcon(ICON_PATHS[GLYPHS[group.key]], 22, 1.7) : '';
      sum.innerHTML = '<span class="ah-sec-ico" aria-hidden="true">' + ico + '</span>' +
        '<span class="ah-sec-txt"><span class="ah-sec-n">' + esc(group.label) + '</span>' +
        (TOPIC_DESC[group.key] ? '<span class="ah-sec-d">' + esc(TOPIC_DESC[group.key]) + '</span>' : '') +
        '</span><span class="ah-q-chev" aria-hidden="true">' + chevSvg() + '</span>';
      sec.appendChild(sum);
      var body = document.createElement('div');
      body.className = 'ah-sec-body';
      (group.children || []).forEach(function (ch) {
        if (ch.children && ch.children.length) {
          var h = document.createElement('h4');
          h.className = 'ah-subg';
          h.textContent = ch.label;
          body.appendChild(h);
          ch.children.forEach(function (leaf) { body.appendChild(questionEl(leaf)); });
        } else {
          body.appendChild(questionEl(ch));
        }
      });
      sec.appendChild(body);
      wrap.appendChild(sec);
    });
    return wrap;
  }

  // Abre el tema y la pregunta de un resultado del buscador y la deja a la vista.
  function openQuestion(topic) {
    var q = QNODES[topic];
    if (!q) return;
    var sec = q.d.parentNode && q.d.parentNode.parentNode;
    if (sec && sec.tagName === 'DETAILS') sec.open = true;
    q.d.open = true;
    q.d.scrollIntoView({ block: 'start' });
  }

  // Página única: saludo, buscador y los seis temas en acordeón.
  function renderHome(node) {
    var frag = document.createDocumentFragment();
    var home = document.createElement('div');
    home.className = 'ah-home';
    frag.appendChild(home);

    var intro = document.createElement('div');
    intro.className = 'ah-intro';
    intro.innerHTML = '<h3>Hola \ud83d\udc4b ¿Con qué te ayudamos?</h3>' +
      '<p>Elige un tema y te damos la respuesta al momento o te ponemos con un agente.</p>';
    home.appendChild(intro);

    var form = document.createElement('form');
    form.className = 'ah-search';
    form.setAttribute('role', 'search');
    form.innerHTML = svgIcon(ICON_PATHS.search, 20, 2) +
      '<input type="text" name="term" inputmode="search" enterkeyhint="search" autocomplete="off" placeholder="Buscar en el centro de ayuda" aria-label="Buscar en el centro de ayuda">';
    home.appendChild(form);
    var searchInput = form.querySelector('input');

    var resWrap = document.createElement('div');
    resWrap.className = 'ah-results';
    resWrap.hidden = true;
    home.appendChild(resWrap);

    var twrap = document.createElement('div');
    twrap.appendChild(renderAccordion(node.children));
    home.appendChild(twrap);

    function goTo(entry) {
      searchInput.value = '';
      runSearch();
      openQuestion(entry.topic);
    }
    function runSearch() {
      var q = searchInput.value.trim();
      if (!q) { resWrap.hidden = true; resWrap.innerHTML = ''; twrap.hidden = false; return; }
      var results = searchKB(q);
      twrap.hidden = true;
      resWrap.hidden = false;
      resWrap.innerHTML = '';
      var head = document.createElement('p');
      head.className = 'ah-eyebrow'; head.style.margin = '0 0 4px';
      head.textContent = results.length ? 'Resultados' : 'Sin resultados';
      resWrap.appendChild(head);
      if (!results.length) {
        var none = document.createElement('p');
        none.className = 'ah-results-empty';
        none.textContent = 'No hemos encontrado nada para “' + q + '”. Prueba con otras palabras o elige un tema.';
        resWrap.appendChild(none);
        var back = document.createElement('button');
        back.type = 'button'; back.className = 'ah-btn ghost'; back.style.marginTop = '10px';
        back.textContent = 'Ver todos los temas';
        back.addEventListener('click', function () { searchInput.value = ''; runSearch(); searchInput.focus(); });
        resWrap.appendChild(back);
        return;
      }
      var list = document.createElement('div'); list.className = 'ah-options';
      results.forEach(function (e) {
        var b = document.createElement('button'); b.className = 'ah-opt'; b.type = 'button';
        b.innerHTML = '<span class="ah-label"><span class="ah-result-title">' + esc(e.label) + '</span>' +
          (e.category ? '<span class="ah-result-cat">' + esc(e.category) + '</span>' : '') + '</span>' +
          '<span class="ah-chev" aria-hidden="true">' + svgIcon(ICON_PATHS.chev, 16, 2.2) + '</span>';
        b.addEventListener('click', function () { goTo(e); });
        list.appendChild(b);
      });
      resWrap.appendChild(list);
    }
    searchInput.addEventListener('input', runSearch);
    form.addEventListener('submit', function (ev) {
      ev.preventDefault();
      var results = searchKB(searchInput.value.trim());
      if (results.length) goTo(results[0]);
    });

    return frag;
  }

  // Formato REAL de los pedidos Shopify: B2C + 6 dígitos (ej. B2C540225),
  // verificado contra la Admin API 2026-08-11 — NO existe ningún "200XXXXXXX"
  // (era de la plataforma antigua y confundía al cliente). Se tolera que
  // escriban con espacios, "#" o en minúsculas.
  function normalizeOrderName(s) {
    return (s || '').toUpperCase().replace(/[\s#]/g, '');
  }
  function isValidOrderName(s) { return /^B2C\d{6,8}$/.test(s); }
  var ORDER_FORMAT_MSG = 'El número de pedido empieza por B2C seguido de 6 dígitos (p. ej. B2C540225). Lo encontrarás en el correo de confirmación.';

  function renderGate(node, onDone) {
    var box = document.createElement('div');
    box.className = 'ah-gate';
    box.innerHTML =
      '<label for="ah-oid">¿Puedes facilitarnos el código de tu pedido, por favor?</label>' +
      '<p class="ah-hint">p. ej. B2C540225 — lo encontrarás en el correo que has recibido.</p>' +
      '<input id="ah-oid" placeholder="B2C540225" autocomplete="off" autocapitalize="characters">' +
      '<label for="ah-email" style="display:block;margin-top:12px">Tu email</label>' +
      '<input id="ah-email" type="email" placeholder="tu@email.com" autocomplete="email">' +
      '<label for="ah-cp" style="display:block;margin-top:12px">Código postal</label>' +
      '<input id="ah-cp" inputmode="numeric" placeholder="28001" autocomplete="postal-code">' +
      '<p class="ah-gate-msg" style="min-height:18px;font-size:13px;margin:8px 0 0"></p>';
    var oid = box.querySelector('#ah-oid'), email = box.querySelector('#ah-email'), cp = box.querySelector('#ah-cp');
    var msg = box.querySelector('.ah-gate-msg');
    oid.value = orderInput; email.value = emailInput; cp.value = postalInput;
    oid.addEventListener('input', function () { orderInput = oid.value; });
    email.addEventListener('input', function () { emailInput = email.value; });
    cp.addEventListener('input', function () { postalInput = cp.value; });
    var btn = document.createElement('button');
    btn.className = 'ah-btn'; btn.textContent = 'Continuar';
    function advance(on) { order = on; if (onDone) { onDone(on); return; } render(); }
    function go() {
      var on = normalizeOrderName(oid.value), em = (email.value || '').trim(), pc = (cp.value || '').trim();
      if (!on || !em) { msg.textContent = 'Necesitamos tu nº de pedido y tu email.'; return; }
      // El CP se pedía pero no se exigía, así que quedaba vacío y el backend
      // denegaba: sin sesión iniciada, email + CP es la ÚNICA forma de probar
      // que el pedido es tuyo, y con el CP en blanco no hay verificación
      // posible. Exigirlo aquí convierte un 403 seguro en una corrección de
      // un campo. Los clientes con sesión pasan igualmente por el id que
      // firma Shopify, así que el CP solo les ahorra el aviso.
      if (!pc) { msg.textContent = 'Necesitamos también el código postal de la entrega para comprobar que el pedido es tuyo.'; return; }
      if (!isValidOrderName(on)) { msg.textContent = ORDER_FORMAT_MSG; return; }
      btn.disabled = true; btn.textContent = 'Buscando…'; msg.textContent = '';
      fetch(API_BASE + '/lookup-order', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email: em, order_name: on, postal_code: pc || null })
      })
        .then(function (r) {
          if (r.ok) { return r.json().then(function (d) { orderData = d; advance(on); }); }
          if (r.status === 403 || r.status === 404) {
            // Datos que no cuadran (verificación): pedimos revisar, sin bloquear el resto.
            btn.disabled = false; btn.textContent = 'Continuar';
            msg.textContent = 'No hemos podido comprobar que ese pedido sea tuyo. Revisa el nº de pedido, el email de la compra y el código postal de la entrega.';
            return null;
          }
          // Backend no disponible (5xx / HTML / otro): continuamos SIN datos en vivo, nunca bloqueamos.
          orderData = null; advance(on); return null;
        })
        .catch(function () { orderData = null; advance(on); });
    }
    btn.addEventListener('click', go);
    [oid, email, cp].forEach(function (el) { el.addEventListener('keydown', function (e) { if (e.key === 'Enter') go(); }); });
    box.appendChild(btn);
    // Salida siempre disponible: identificarse sirve para darle SU dato, no para
    // cobrarle un peaje. Quien no pueda o no quiera (no encuentra el número, es
    // un regalo, sólo viene a leer) sigue adelante sin datos en vivo, que es
    // exactamente lo que veía todo el mundo mientras el gate era inalcanzable.
    var skip = document.createElement('button');
    skip.type = 'button';
    skip.className = 'ah-btn ghost';
    skip.style.marginTop = '10px';
    skip.textContent = 'Continuar sin identificar el pedido';
    skip.addEventListener('click', function () { orderData = null; advance(null); });
    box.appendChild(skip);
    var skipHint = document.createElement('p');
    skipHint.className = 'ah-hint';
    skipHint.style.margin = '8px 0 0';
    skipHint.textContent = 'Verás la información general, pero no el estado ni el seguimiento de tu pedido.';
    box.appendChild(skipHint);
    return box;
  }

  function renderAnswer(node, answerHost) {
    var t = topics[node.topic] || {};
    var ch = CHANNEL[t.resolution_channel] || CHANNEL.inform;
    var card = document.createElement('div');
    card.className = 'ah-answer';
    var meta = '';
    var ctaHtml = t.cta && t.cta.url ? '<a class="ah-cta" href="' + esc(t.cta.url) + '">' + esc(t.cta.label || 'Continuar') + ' →</a>' : '';
    // Botón de seguimiento EN VIVO (correcciones ATC 2026-07-30): solo cuando
    // el gate verificó el pedido y Outvio nos dio un tracking real.
    if (TRACKING_TOPICS.indexOf(node.topic) >= 0 && orderData && orderData.tracking_url) {
      ctaHtml += '<a class="ah-cta" href="' + esc(orderData.tracking_url) + '" target="_blank" rel="noopener">Seguimiento en vivo ↗</a>';
    }
    // Gestión con la agencia que lleva el paquete. Solo cuando el pedido está
    // identificado y sabemos el transportista: sin eso no podemos mandarle a la
    // web correcta y un listado de todas las agencias es lo que ya existe y no
    // funciona. Va ANTES del texto porque para quien no ha recibido su pedido
    // esto es la respuesta, no un complemento.
    var carrierHtml = '';
    if (CARRIER_TOPICS.indexOf(node.topic) >= 0 && orderData && orderData.tracking_company) {
      var cinfo = carrierFor(orderData.tracking_company);
      var cname = (cinfo && cinfo.name) || String(orderData.tracking_company);
      carrierHtml = '<div class="ah-carrier"><p class="ah-carrier-t">' +
        svgIcon(ICON_PATHS.truck || ICON_PATHS.box, 16, 1.7) +
        ' Tu pedido lo entrega <b>' + esc(cname) + '</b></p>';
      var links = '';
      if (orderData.tracking_url) {
        links += '<a class="ah-cta" href="' + esc(orderData.tracking_url) + '" target="_blank" rel="noopener">Ver dónde está ahora ↗</a>';
      }
      if (cinfo) {
        links += '<a class="ah-cta ghost" href="' + esc(cinfo.manage) + '" target="_blank" rel="noopener">Cambiar la entrega en ' + esc(cname) + ' ↗</a>';
      }
      carrierHtml += links ? '<div class="ah-carrier-a">' + links + '</div>' : '';
      carrierHtml += '<p class="ah-carrier-h">Cambiar la dirección, dar una franja horaria, autorizar que lo dejen ' +
        'con un vecino o desviarlo a un punto de recogida lo hace <b>' + esc(cname) + '</b> directamente, y suele ser al momento' +
        (cinfo && cinfo.phone ? ' (también por teléfono, en el ' + esc(cinfo.phone) + ')' : '') + '. ' +
        'Si ya lo has intentado y sigue sin resolverse, escríbenos abajo y lo reclamamos nosotros.</p></div>';
    }
    var inputs = (t.required_inputs || []).filter(function (x) { return x !== 'order_id'; });
    if (inputs.length) {
      meta += '<div class="ah-row"><span class="ah-k">Lo que te pediremos</span>' +
        inputs.map(function (i) { return '<span class="ah-chip">' + esc(INPUT_LABELS[i] || i) + '</span>'; }).join('') + '</div>';
    }
    // Si la respuesta necesita datos del pedido y no los tenemos (lookup no
    // disponible o pedido no identificado), quitamos la frase que depende del
    // token pero MANTENEMOS el resto, que es útil sin datos en vivo. Solo si no
    // queda nada que decir mostramos el aviso de que no pudimos consultarlo.
    var raw = t.answer_template || '';
    var answerHtml;
    // Las respuestas de las preguntas frecuentes mandan sobre el texto de la KB:
    // son las revisadas por ATC y traen listas, enlaces y capturas.
    if (FAQ_HTML[node.topic]) {
      answerHtml = FAQ_HTML[node.topic];
    } else if (/\[[^\]]+\]/.test(raw) && !orderData) {
      // Sin datos en vivo quitamos SOLO las frases que dependen del token y
      // dejamos el resto, que sigue siendo útil. La antigua coletilla («no hemos
      // podido consultar el estado en vivo…») se retiró a petición de ATC: no
      // aporta nada al cliente y ensucia la respuesta.
      var stripped = stripTokenSentences(raw);
      answerHtml = stripped ? formatAnswer(stripped) : '';
    } else {
      answerHtml = formatAnswer(raw);
    }
    if (t.resolution_channel === 'human_action') {
      meta += '<div class="ah-escalate"><b>¿Necesitas que lo veamos nosotros?</b> Al continuar, abrimos tu caso a un agente <b>con todo el contexto ya adjunto</b> (pedido, tipo de consulta y datos), para que lo resuelva sin que tengas que repetir nada.</div>';
    }
    // El enlace "Ver artículo completo" se retiró a propósito (ATC, 11-09-2026):
    // mandaba al cliente a otra web a terminar de leer, y los artículos que
    // exigen su dato o su gestión son justo los peor valorados del centro de
    // ayuda (seguimiento 13% útil, canjear saldo 34%, dar de baja 4%). La
    // respuesta tiene que estar completa en el hub; `fd_article` se conserva en
    // la KB como referencia editorial para saber de dónde salió cada texto.

    card.innerHTML = '<div class="ah-body">' +
      carrierHtml + '<div class="ah-text">' + answerHtml + '</div>' + ctaHtml + '</div>' +
      (meta ? '<div class="ah-meta">' + meta + '</div>' : '');
    var ptool = PRODUCT_TOOL[node.topic];
    if (ptool) {
      var body = card.querySelector('.ah-body') || card;
      body.appendChild(renderProductTool(ptool, node, t, answerHost));
    }
    var variantHere = FORM_VARIANTS[node.topic];
    if (t.resolution_channel === 'human_action' || node.topic === 'free_text_escalation' ||
        (variantHere && variantHere.fiscalFields) ||
        EXTRA_AGENT_TOPICS.indexOf(node.topic) >= 0) {
      var fbtn = document.createElement('button');
      fbtn.className = 'ah-btn';
      // La factura no es "una consulta a un agente": es una gestión concreta y
      // el boton tiene que decir lo que hace.
      fbtn.textContent = (variantHere && variantHere.fiscalFields)
        ? 'Pedir la factura a nombre de empresa →'
        : 'Enviar mi consulta a un agente →';
      fbtn.addEventListener('click', function () { openForm(node, t, answerHost); });
      var host = card.querySelector('.ah-meta') || card.querySelector('.ah-body') || card;
      host.appendChild(fbtn);
    }
    return card;
  }

  // Panel interactivo: el cliente escribe el producto (y una pregunta) y
  // consultamos en vivo el backend. Degradación robusta: si no hay respuesta
  // útil, invitamos a reformular o a abrir consulta a un agente (nunca email).
  function renderProductTool(cfg, node, t, answerHost) {
    var escalate = function () { openForm(node, t, answerHost); };
    var box = document.createElement('div');
    box.className = 'ah-ptool';
    var html = '<label for="ah-p-prod">' + esc(cfg.prodLabel) + '</label>' +
      '<input id="ah-p-prod" type="text" autocomplete="off" placeholder="Ej.: Aceite de coco virgen Bio Planeta Huerto 1 l">';
    if (cfg.prodHint) html += '<p class="ah-ptool-hint">' + esc(cfg.prodHint) + '</p>';
    if (cfg.mode === 'question') {
      html += '<label for="ah-p-q">' + esc(cfg.qLabel) + '</label>' +
        '<textarea id="ah-p-q" class="ah-textarea" rows="3" placeholder="Escribe tu pregunta…"></textarea>';
      if (cfg.qHint) html += '<p class="ah-ptool-hint">' + esc(cfg.qHint) + '</p>';
    }
    html += '<p class="ah-ptool-out" aria-live="polite"></p>';
    box.innerHTML = html;
    var prod = box.querySelector('#ah-p-prod');
    var q = box.querySelector('#ah-p-q');
    var out = box.querySelector('.ah-ptool-out');
    var btn = document.createElement('button');
    btn.className = 'ah-btn'; btn.textContent = cfg.btn;
    function go() {
      var pv = (prod.value || '').trim();
      var qv = q ? (q.value || '').trim() : '';
      if (!pv) { out.innerHTML = '<span class="ah-ptool-hint">Escribe el nombre del artículo tal y como aparece en la web.</span>'; prod.focus(); return; }
      if (cfg.mode === 'question' && !qv) { out.innerHTML = '<span class="ah-ptool-hint">Cuéntanos qué quieres saber del producto.</span>'; q.focus(); return; }
      submitProductQuery(cfg, pv, qv, btn, out, escalate);
    }
    btn.addEventListener('click', go);
    [prod, q].forEach(function (el) { if (el) el.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' && (el === prod || !e.shiftKey)) { e.preventDefault(); go(); }
    }); });
    box.appendChild(btn);
    return box;
  }

  function submitProductQuery(cfg, prodText, question, btn, out, escalate) {
    var label = btn.textContent;
    btn.disabled = true; btn.textContent = 'Consultando…';
    out.innerHTML = '';
    function finish() { btn.disabled = false; btn.textContent = label; }
    // Caducidad y disponibilidad: primero EN CLIENTE con los datos públicos de
    // la propia tienda (instantáneo, sin depender del backend).
    if (cfg.storefront) {
      storefrontProductQuery(cfg, prodText, out, escalate)
        .then(function (res) {
          if (!res.handled) return backendProductQuery(cfg, prodText, question, out, escalate, res.info, res.near);
        })
        .then(finish, finish);
      return;
    }
    backendProductQuery(cfg, prodText, question, out, escalate, null, null).then(finish, finish);
  }

  function backendProductQuery(cfg, prodText, question, out, escalate, sfInfo, near) {
    var isUrl = /^https?:\/\//i.test(prodText);
    var body = {};
    if (cfg.mode === 'question') {
      body.question = question;
      if (isUrl) body.product_url = prodText; else body.product_text = prodText;
    } else {
      // caducidad / disponibilidad aceptan sku | product_text | product_url
      if (isUrl) body.product_url = prodText;
      else if (/^0*\d{4,10}$/.test(prodText)) body.sku = prodText;
      else body.product_text = prodText;
    }
    function degraded() {
      // Backend no disponible: si el storefront ya identificó el producto,
      // damos la respuesta honesta específica en vez del genérico.
      if (sfInfo) { renderStorefrontSoftResult(cfg, sfInfo, out, escalate); return; }
      productToolFallback(out, escalate);
    }
    return fetch(API_BASE + cfg.endpoint, {
      method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body)
    })
      .then(function (r) {
        if (r.ok) { return r.json().then(function (d) { renderProductResult(cfg, d, out, escalate, sfInfo, near); }); }
        // 4xx/5xx/HTML → degradamos sin bloquear (nunca mostramos email).
        degraded();
        return null;
      })
      .catch(degraded);
  }

  // Respuesta honesta con lo que el storefront SÍ sabe, cuando el backend no
  // puede enriquecer (kill switch off / error). Nunca un callejón sin salida.
  function renderStorefrontSoftResult(cfg, info, out, escalate) {
    var title = esc(info.title);
    if (cfg.storefront === 'expiry') {
      // Sin backend no se puede distinguir «no caduca» de «no lo tenemos
      // registrado»: la ficha solo publica `custom.fecha_caducidad` en los SKUs
      // de liquidación por caducidad (204 de 9.501 medidos el 17-09-2026), así
      // que su ausencia no dice nada sobre si el producto es perecedero.
      out.innerHTML = pcard('warn', '<p><b>' + title + '</b>: su ficha no publica fecha de caducidad y ahora mismo no podemos consultarla.</p>' +
        '<p class="ah-ptool-hint">Va impresa en el propio envase. Si la necesitas antes de comprar, un agente la comprueba y te la confirma. ' + productLink(info) + '</p>');
      appendAgentBtn(out, escalate, 'Confirmar con un agente →');
      return;
    }
    if (cfg.storefront === 'availability') {
      out.innerHTML = pcard('warn', '<p><b>' + title + '</b>: agotado ahora mismo.</p>' +
        '<p class="ah-ptool-hint">Pulsa «Avísame cuando esté disponible» en la ficha y te escribimos en cuanto vuelva. ' +
        productLink(info, 'Ir a la ficha') + '</p>');
      appendAgentBtn(out, escalate);
      return;
    }
    productToolFallback(out, escalate);
  }

  // Resuelve el producto por NOMBRE con la búsqueda predictiva pública y lee
  // la vista JSON /products/{handle}?view=caducidad (mismo metafield público
  // custom.fecha_caducidad que pinta la ficha). Devuelve una promesa de
  // {handled, info}: handled=true si la consulta quedó respondida aquí;
  // handled=false = que lo intente el backend, con `info` (si existe) para
  // que su fallback sea específico y no el genérico. Nunca lanza.
  // Título comparable: sin acentos, sin puntuación y con los espacios juntos.
  // Gemelo de `_normalize_title` del backend (product_resolver.py) — los dos
  // deciden lo mismo: si el producto que tenemos delante ES el que pidió el
  // cliente, no si se le parece.
  function normTitle(v) {
    return (v || '').normalize('NFKD').replace(/[\u0300-\u036f]/g, '')
      .toLowerCase().replace(/[^a-z0-9]+/g, ' ').trim().replace(/\s+/g, ' ');
  }

  function storefrontProductQuery(cfg, prodText, out, escalate) {
    var MISS = { handled: false, info: null };
    // Se piden 5 y no 1 para poder DESCARTAR: `suggest.json` es una búsqueda
    // difusa y siempre devuelve algo, así que con limit=1 el primer resultado
    // se tomaba por bueno sin más. Caso real del 11-09-2026: a «Harina Blanca
    // de Trigo Fuerza Eco Planeta Huerto 5 Kg» respondía «Harina Blanca de
    // Trigo Eco Planeta Huerto 800 g: ✅ disponible ahora mismo» — otro
    // producto, otro formato, y afirmado con un tick verde.
    var url = '/search/suggest.json?q=' + encodeURIComponent(prodText) +
      '&resources[type]=product&resources[limit]=5';
    var wanted = normTitle(prodText);
    return fetch(url)
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (d) {
        var prods = (d && d.resources && d.resources.results && d.resources.results.products) || [];
        // Sólo vale el título IDÉNTICO al que pegó el cliente. Cualquier otra
        // cosa la decide el backend, que resuelve por nombre exacto contra el
        // catálogo y alcanza productos que este buscador no devuelve (el de
        // 5 Kg del caso de arriba existe, con SKU 339938, y no salía).
        var p = null;
        for (var i = 0; i < prods.length; i++) {
          if (prods[i] && prods[i].handle && normTitle(prods[i].title) === wanted) { p = prods[i]; break; }
        }
        // Guardamos el primer candidato aunque se descarte: si nadie resuelve,
        // ofrecerlo como «¿te refieres a…?» es mejor que un "no encontrado"
        // que culpa al cliente de no copiar bien lo que sí copió bien.
        var near = (!p && prods[0] && prods[0].handle) ? prods[0] : null;
        if (!p) return { handled: false, info: null, near: near };
        return fetch('/products/' + encodeURIComponent(p.handle) + '?view=caducidad')
          .then(function (r) { return r.ok ? r.text() : null; })
          .then(function (txt) {
            var info = null;
            try { info = JSON.parse(txt); } catch (e) { /* plantilla aún no desplegada */ }
            if (!info || !info.title) return MISS;
            // El producto SÍ existe y lo hemos identificado: aunque aquí no
            // haya dato (una caducidad sin publicar), el backend hereda esta
            // ficha para que su fallback no diga «no lo encontramos».
            info.confirmed = true;
            if (cfg.storefront === 'expiry') {
              return { handled: renderStorefrontExpiry(info, out, escalate), info: info };
            }
            if (cfg.storefront === 'availability') {
              return { handled: renderStorefrontAvailability(info, out, escalate), info: info };
            }
            return MISS;
          });
      })
      .catch(function () { return MISS; });
  }

  function productLink(info, text) {
    return '<a class="ah-article" href="' + esc(info.url) + '" target="_blank" rel="noopener">' +
      esc(text || 'Ver ficha del producto') + ' ↗</a>';
  }

  function renderStorefrontExpiry(info, out, escalate) {
    var title = esc(info.title);
    if (info.expiry) {
      out.innerHTML = pcard('ok', '<p><b>' + title + '</b>: fecha de caducidad <span class="ah-ptool-eta">' +
        esc(fmtDate(info.expiry)) + '</span>.</p>' +
        '<p class="ah-ptool-hint">Es la fecha del lote actual a la venta (la misma que ves en la ficha); la de tu unidad viene impresa en el propio producto. ' +
        productLink(info) + '</p>');
      return true;
    }
    // Sin fecha publicada: puede ser no perecedero o faltar el dato → que lo
    // intente el backend (FEFO Odoo); si tampoco, su fallback ofrece agente.
    return false;
  }

  function renderStorefrontAvailability(info, out, escalate) {
    var title = esc(info.title);
    if (info.available) {
      out.innerHTML = pcard('ok', '<p><b>' + title + '</b>: ✅ disponible ahora mismo.</p>' +
        '<p class="ah-ptool-hint">' + productLink(info, 'Ir a la ficha para comprarlo') + '</p>');
      return true;
    }
    // Agotado: el backend puede saber CUÁNDO vuelve (ETA) → inténtalo; si no
    // responde, renderProductResult/productToolFallback ya cubren el resto.
    return false;
  }

  function pcard(cls, text) { return '<div class="ah-ptool-card ' + cls + '">' + text + '</div>'; }

  // Botón de escalado inline: convierte cualquier "no hemos podido" en una
  // acción real (formulario con contexto → agente). Nunca un email, nunca un
  // callejón sin salida.
  function appendAgentBtn(out, escalate, text) {
    if (!escalate) return;
    var b = document.createElement('button');
    b.className = 'ah-btn ghost'; b.style.marginTop = '10px';
    b.textContent = text || 'Que lo revise un agente →';
    b.addEventListener('click', escalate);
    out.appendChild(b);
  }

  function productToolFallback(out, escalate) {
    out.innerHTML = '<span class="ah-ptool-hint">No hemos podido consultarlo automáticamente ahora mismo. ' +
      'Vuelve a intentarlo en unos minutos o deja que lo revise un agente con tu consulta.</span>';
    appendAgentBtn(out, escalate);
  }

  function fmtDate(iso) {
    if (!iso) return '';
    var m = /^(\d{4})-(\d{2})-(\d{2})/.exec(iso);
    return m ? (m[3] + '/' + m[2] + '/' + m[1]) : iso;
  }

  // El dato no está registrado. No es un error, así que se dice tal cual y se
  // ofrece la única vía que puede resolverlo, en vez de un «reinténtalo» que no.
  function renderNoDataResult(cfg, d, out, escalate, sfInfo) {
    var title = esc(d.product_title || (sfInfo && sfInfo.title) || '') || 'Este producto';
    if (cfg.endpoint === '/product-expiry') {
      out.innerHTML = pcard('warn', '<p><b>' + title + '</b>: no tenemos registrada la fecha de caducidad del lote que hay ahora mismo en almacén.</p>' +
        '<p class="ah-ptool-hint">Va impresa en el propio envase. Si la necesitas antes de comprar, un agente la comprueba y te la confirma.</p>' +
        ((sfInfo && sfInfo.url) ? '<p class="ah-ptool-hint">' + productLink(sfInfo) + '</p>' : ''));
      appendAgentBtn(out, escalate, 'Que un agente la compruebe →');
      return;
    }
    productToolFallback(out, escalate);
  }

  function renderProductResult(cfg, d, out, escalate, sfInfo, near) {
    d = d || {};
    var title = d.product_title ? esc(d.product_title) : 'el producto';
    var notFound = '<span class="ah-ptool-hint">No hemos encontrado ese producto. Copia y pega el nombre exacto tal y como aparece en la web.</span>';
    if (d.status === 'product_not_found') {
      // Pedirle que copie «el nombre exacto» a quien acaba de copiarlo exacto
      // es el peor final posible: no tiene nada que corregir y vuelve a
      // intentarlo igual. Antes de decirlo, se agota lo que ya sabemos.
      if (sfInfo && sfInfo.confirmed) {
        // La tienda SÍ tiene ese producto: lo que falta es el dato concreto.
        renderStorefrontSoftResult(cfg, sfInfo, out, escalate);
        return;
      }
      if (near && near.title) {
        // Había un parecido y se descartó por no ser el mismo: se ofrece como
        // pregunta, nunca como respuesta.
        out.innerHTML = '<span class="ah-ptool-hint">No hemos encontrado ese producto con ese nombre exacto. ' +
          '¿Te refieres a <b>' + esc(near.title) + '</b>?</span>' +
          (near.url ? '<p class="ah-ptool-hint"><a class="ah-article" href="' + esc(near.url) +
            '" target="_blank" rel="noopener">Ver esa ficha ↗</a></p>' : '');
        appendAgentBtn(out, escalate);
        return;
      }
      out.innerHTML = notFound; appendAgentBtn(out, escalate); return;
    }
    // `unavailable` es un fallo de LECTURA: reintentar tiene sentido.
    if (d.status === 'unavailable') { productToolFallback(out, escalate); return; }
    // `no_data` no es un fallo: el backend ha contestado que ese dato no está
    // registrado, así que «vuelve a intentarlo en unos minutos» manda a repetir
    // una consulta cuyo resultado no puede cambiar. Medido en producción el
    // 17-09-2026: de los 9.501 SKUs vendibles con stock fechado, 399
    // perecederos tienen TODOS sus lotes con la caducidad centinela del flujo
    // documental (año 2999) porque el albarán del proveedor nunca la trajo —
    // encabezados por el vinagre de manzana PH 1L con 6.635 uds. Su fecha no
    // existe en ningún sistema nuestro: solo está impresa en el envase.
    if (d.status === 'no_data') { renderNoDataResult(cfg, d, out, escalate, sfInfo); return; }
    if (cfg.endpoint === '/product-question') {
      out.innerHTML = pcard('ok', '<p>' + esc(d.answer || '') + '</p>' +
        '<p class="ah-ptool-hint">Respuesta basada en la ficha de <b>' + title + '</b>. ¿No es lo que buscabas? Reformula la pregunta o deja que lo revise un agente.</p>');
      appendAgentBtn(out, escalate, 'No me sirve, que lo vea un agente →');
      return;
    }
    if (cfg.endpoint === '/product-expiry') {
      if (d.status === 'no_expiry_tracked') {
        out.innerHTML = pcard('ok', '<p>' + title.charAt(0).toUpperCase() + title.slice(1) +
          ' no lleva fecha de caducidad (no es un producto perecedero).</p>'); return;
      }
      var exp = '<p><b>' + title + '</b>: la caducidad más próxima del stock que servimos es el <span class="ah-ptool-eta">' + esc(fmtDate(d.expiry_date)) + '</span>';
      exp += d.lot ? ' (lote ' + esc(d.lot) + ').' : '.';
      exp += '</p><p class="ah-ptool-hint">La fecha exacta de tu unidad viene impresa en el producto; puede variar ligeramente según el lote enviado.</p>';
      out.innerHTML = pcard('ok', exp); return;
    }
    if (cfg.endpoint === '/product-availability') {
      if (d.status === 'in_stock') {
        out.innerHTML = pcard('ok', '<p><b>' + title + '</b>: ✅ disponible ahora mismo.</p>'); return;
      }
      if (d.status === 'incoming') {
        var when = d.eta_date ? (' Fecha prevista de llegada: <span class="ah-ptool-eta">' + esc(fmtDate(d.eta_date)) + '</span>.')
          : (d.eta_days != null ? (' Llega en aprox. <span class="ah-ptool-eta">' + esc(String(d.eta_days)) + ' días</span>.') : '');
        out.innerHTML = pcard('warn', '<p><b>' + title + '</b>: 🚚 temporalmente sin stock, pero ya viene de camino.' + when +
          '</p><p class="ah-ptool-hint">Pulsa «Avísame cuando esté disponible» en la ficha y te escribiremos en cuanto vuelva.</p>'); return;
      }
      if (d.status === 'out_of_stock') {
        out.innerHTML = pcard('warn', '<p><b>' + title + '</b>: agotado sin fecha de reposición por ahora.</p>' +
          '<p class="ah-ptool-hint">Pulsa «Avísame cuando esté disponible» en la ficha del producto y te avisaremos en cuanto vuelva.</p>'); return;
      }
      out.innerHTML = notFound; appendAgentBtn(out, escalate); return;
    }
    productToolFallback(out, escalate);
  }

  function openForm(node, t, host) {
    var variant = FORM_VARIANTS[node.topic] || null;
    // Las variantes van SIEMPRE por /escalation: acepta adjuntos y no exige
    // pedido. /incident queda para incidencias de pedido reales (roto, falta,
    // erróneo, caducado), que sí requieren pedido verificado.
    // La factura a empresa tiene endpoint propio (`/invoice-request`), que crea
    // el ticket de Odoo con los datos fiscales estructurados en vez de dentro
    // de un texto libre que el agente tendría que releer y teclear.
    var kind = variant && variant.fiscalFields ? 'invoice'
      : (!variant && (t.required_inputs || []).indexOf('photo') >= 0 ? 'incident' : 'escalation');
    formCtx = { label: node.label, topicId: node.topic, kind: kind, variant: variant,
      incidentType: INCIDENT_TYPE_BY_TOPIC[node.topic] || 'other', node: node, host: host };
    paintForm();
  }

  // El formulario ya no ocupa una pantalla propia: sustituye al cuerpo de la
  // respuesta abierta, así el cliente no pierde de vista dónde estaba.
  function paintForm() {
    var host = formCtx && formCtx.host;
    if (!host) return;
    host.innerHTML = '';
    // Los flujos sin pedido (fallo de compra, pago duplicado, gestiones de
    // cuenta) no deben prometer "contexto de tu pedido".
    var noOrderCtx = !!(formCtx.variant && formCtx.variant.noOrder);
    if (formCtx.success) {
      var ok = document.createElement('div');
      ok.className = 'ah-a-ok';
      ok.innerHTML = '<b>¡Gracias! Hemos recibido tu consulta.</b><br>' +
        (noOrderCtx
          ? 'Un agente la revisará y te responderá lo antes posible (normalmente en 24 h hábiles).'
          : 'Un agente la revisará con todo el contexto de tu pedido y te responderá lo antes posible (normalmente en 24 h hábiles).');
      host.appendChild(ok);
      return;
    }
    var fi = document.createElement('p');
    fi.className = 'ah-form-intro';
    fi.textContent = noOrderCtx
      ? 'Cuéntanos y lo gestionamos lo antes posible.'
      : 'Cuéntanos y lo gestionamos con todo el contexto de tu pedido.';
    host.appendChild(fi);
    host.appendChild(renderForm());
    var back = document.createElement('button');
    back.type = 'button';
    back.className = 'ah-btn ghost';
    back.textContent = '← Volver a la respuesta';
    back.addEventListener('click', closeForm);
    host.appendChild(back);
  }

  function closeForm() {
    var ctx = formCtx;
    formCtx = null;
    if (ctx && ctx.host && ctx.node) paintAnswer(ctx.node, ctx.host);
  }

  function renderForm() {
    var box = document.createElement('div');
    box.className = 'ah-gate';
    var v = formCtx.variant || {};
    var photoLabel = v.photoLabel ||
      (formCtx.kind === 'incident' ? 'Foto (opcional, nos ayuda a resolverlo antes)' : null);
    var html = '';
    if (!v.noOrder) {
      html += '<label for="ah-f-order">Nº de pedido</label>' +
        '<input id="ah-f-order" placeholder="B2C540225" autocomplete="off" autocapitalize="characters">' +
        // El CP es la SEGUNDA mitad de la verificación de titularidad: sin él,
        // un cliente que no ha iniciado sesión no puede demostrar que el pedido
        // es suyo y el backend responde 403 pase lo que pase. Se pide aquí y
        // también en el bloque de identificación que ahora abre la respuesta de
        // los temas que dependen de datos reales (`LOOKUP_TOPICS`): hasta la
        // unificación, `renderGate` era inalcanzable —ninguna hoja del árbol
        // llevaba `requires`— y la verificación por email+CP tenía CERO usos en
        // las 53.837 peticiones del histórico.
        '<label for="ah-f-cp" style="display:block;margin-top:12px">Código postal de la entrega</label>' +
        '<p class="ah-hint">Nos sirve para comprobar que el pedido es tuyo.</p>' +
        '<input id="ah-f-cp" inputmode="numeric" placeholder="28001" autocomplete="postal-code">';
    }
    if (v.askName) {
      html += '<label for="ah-f-name" style="display:block;margin-top:12px">Tu nombre</label>' +
        '<input id="ah-f-name" type="text" placeholder="Nombre y apellidos" autocomplete="name">';
    }
    if (v.reasons && v.reasons.length) {
      html += '<label for="ah-f-reason" style="display:block;margin-top:12px">' + esc(v.reasonLabel || 'Motivo') + '</label>' +
        '<select id="ah-f-reason"><option value="">Elige una opción…</option>' +
        v.reasons.map(function (r) { return '<option value="' + esc(r) + '">' + esc(r) + '</option>'; }).join('') +
        '</select>';
    }
    html += '<label for="ah-f-email" style="display:block;margin-top:12px">Email</label>' +
      '<input id="ah-f-email" type="email" placeholder="tu@email.com" autocomplete="email">' +
      '<label for="ah-f-msg" style="display:block;margin-top:12px">' + esc(v.msgLabel || 'Cuéntanos tu consulta') + '</label>' +
      '<textarea id="ah-f-msg" class="ah-textarea" rows="4" placeholder="' + esc(v.msgPlaceholder || 'Describe lo que necesitas…') + '"></textarea>';
    if (v.fiscalFields) {
      // Los seis que Odoo necesita para emitir la factura. Van con los nombres
      // que usa el cliente, no los del schema, y con autocomplete para que el
      // navegador rellene lo que ya sabe.
      html += FISCAL_FIELDS.map(function (f) {
        return '<label for="' + f.id + '" style="display:block;margin-top:12px">' + esc(f.label) + '</label>' +
          '<input id="' + f.id + '" type="text" placeholder="' + esc(f.ph) + '"' +
          (f.autocomplete ? ' autocomplete="' + f.autocomplete + '"' : '') + '>';
      }).join('');
    }
    if (photoLabel) {
      html += '<label for="ah-f-photo" style="display:block;margin-top:12px">' + esc(photoLabel) + '</label>' +
        '<input id="ah-f-photo" type="file" accept="image/*" multiple>';
    }
    html += '<p class="ah-gate-msg" style="min-height:18px;font-size:.82rem;margin:8px 0 0"></p>';
    box.innerHTML = html;
    var refs = {
      orderI: box.querySelector('#ah-f-order'),
      postalI: box.querySelector('#ah-f-cp'),
      nameI: box.querySelector('#ah-f-name'),
      reasonI: box.querySelector('#ah-f-reason'),
      emailI: box.querySelector('#ah-f-email'),
      msgI: box.querySelector('#ah-f-msg'),
      photoI: box.querySelector('#ah-f-photo'),
      statusP: box.querySelector('.ah-gate-msg'),
      fiscal: v.fiscalFields ? FISCAL_FIELDS.map(function (f) {
        return { field: f, el: box.querySelector('#' + f.id) };
      }) : null
    };
    if (refs.orderI) refs.orderI.value = order || orderInput || '';
    if (refs.postalI) refs.postalI.value = postalInput || '';
    refs.emailI.value = emailInput || '';
    var btn = document.createElement('button');
    btn.className = 'ah-btn'; btn.textContent = 'Enviar';
    btn.addEventListener('click', function () { submitForm(refs, btn); });
    box.appendChild(btn);
    return box;
  }

  function submitForm(refs, btn) {
    var v = formCtx.variant || {};
    var statusP = refs.statusP;
    var on = refs.orderI ? normalizeOrderName(refs.orderI.value) : '';
    var nm = refs.nameI ? (refs.nameI.value || '').trim() : '';
    var reason = refs.reasonI ? (refs.reasonI.value || '').trim() : '';
    var em = (refs.emailI.value || '').trim();
    var txt = (refs.msgI.value || '').trim();
    // El CP sale del formulario y se guarda en `postalInput` para que, si el
    // cliente sigue navegando el árbol, no tenga que volver a teclearlo. Se
    // cae a lo que ya hubiera escrito en `renderGate` si este formulario no
    // pide pedido (variantes `noOrder`, que no llevan campo de CP).
    var pc = refs.postalI ? (refs.postalI.value || '').trim() : postalInput;
    if (refs.postalI) postalInput = pc;
    var files = (refs.photoI && refs.photoI.files) ? Array.prototype.slice.call(refs.photoI.files, 0, 5) : [];
    if (!em || (!txt && !v.msgOptional) || (!v.noOrder && !on)) {
      statusP.textContent = v.noOrder ? 'Necesitamos tu email y tu consulta.'
        : (v.msgOptional ? 'Necesitamos el nº de pedido y tu email.' : 'Necesitamos nº de pedido, email y tu consulta.');
      return;
    }
    // Datos fiscales: sin ellos no se puede emitir la factura, así que se piden
    // aquí y no en un ida y vuelta por correo con el agente.
    var fiscal = {};
    if (refs.fiscal) {
      for (var fi = 0; fi < refs.fiscal.length; fi++) {
        var fv = (refs.fiscal[fi].el && refs.fiscal[fi].el.value || '').trim();
        if (!fv && refs.fiscal[fi].field.required) {
          statusP.textContent = 'Nos falta un dato para poder emitir la factura: ' + refs.fiscal[fi].field.label + '.';
          refs.fiscal[fi].el.focus();
          return;
        }
        if (fv) fiscal[refs.fiscal[fi].field.key] = fv;
      }
    }
    // Bloqueo si el pedido no tiene el formato real (correcciones ATC 07/08 y
    // 11/08): B2C + 6 dígitos. Evita tickets con pedidos inverificables.
    if (!v.noOrder && !isValidOrderName(on)) {
      statusP.textContent = ORDER_FORMAT_MSG;
      return;
    }
    if (v.fiscalFields && !nm) {
      statusP.textContent = 'Necesitamos tu nombre para emitir la factura.';
      return;
    }
    if (v.reasons && v.reasons.length && !reason) {
      statusP.textContent = 'Elige el motivo en el desplegable, por favor.';
      return;
    }
    if (v.minMsg && txt.length < v.minMsg) {
      statusP.textContent = 'Cuéntanos un poco más para que el agente no tenga que volver a preguntarte 🙂';
      return;
    }
    if (v.photoRequired && !files.length) {
      statusP.textContent = 'Necesitamos el documento de verificación adjunto para poder gestionarlo.';
      return;
    }
    // El motivo viaja como primera línea del mensaje: el agente lo ve mascado.
    if (reason) txt = 'Motivo: ' + reason + '\n\n' + txt;
    btn.disabled = true; btn.textContent = 'Enviando…'; statusP.textContent = '';
    function fail() {
      btn.disabled = false; btn.textContent = 'Enviar';
      statusP.textContent = 'No hemos podido enviar tu consulta ahora. Inténtalo de nuevo en unos minutos, por favor.';
    }
    function done() { formCtx.success = true; paintForm(); }
    function sendEscalation(ids) {
      var payload = { email: em, postal_code: pc || null, message: '[' + formCtx.label + '] ' + txt };
      // Sin pedido → NO mandamos order_name (el backend etiqueta sin_pedido).
      if (!v.noOrder && on) payload.order_name = on;
      if (nm) payload.customer_name = nm;
      if (ids && ids.length) payload.photo_ids = ids;
      fetch(API_BASE + '/escalation', { method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload) })
        .then(function (r) { r.ok ? done() : fail(); }).catch(fail);
    }
    // Factura a nombre de empresa: ticket de Odoo con los campos fiscales
    // separados, no un párrafo que el agente tenga que interpretar.
    function sendInvoice(ids) {
      var payload = {
        email: em, order_name: on, postal_code: pc || null,
        customer_name: nm, observations: txt || null
      };
      for (var k in fiscal) { if (Object.prototype.hasOwnProperty.call(fiscal, k)) payload[k] = fiscal[k]; }
      fetch(API_BASE + '/invoice-request', { method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload) })
        .then(function (r) {
          if (r.ok) { done(); return; }
          // Mismo criterio que /incident: el 403 es uniforme a propósito (no
          // distingue "no existe" de "no puedo verificarte"), así que no puede
          // dejar al cliente sin canal. Se cae a /escalation con los datos
          // fiscales YA recogidos dentro del mensaje — el agente los tiene
          // igual, solo que sin estructurar, y el ticket va "sin verificar".
          if (r.status === 403) {
            var lines = ['Solicitud de factura a nombre de empresa:'];
            FISCAL_FIELDS.forEach(function (f) {
              if (fiscal[f.key]) lines.push('- ' + f.label + ': ' + fiscal[f.key]);
            });
            txt = lines.join('\n') + (txt ? '\n\nObservaciones: ' + txt : '');
            sendEscalation(ids);
            return;
          }
          fail();
        }).catch(fail);
    }
    function sendIncident(ids) {
      fetch(API_BASE + '/incident', { method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email: em, order_name: on, postal_code: pc || null, incident_type: formCtx.incidentType, description: '[' + formCtx.label + '] ' + txt, photo_ids: ids }) })
        .then(function (r) {
          if (r.ok) { done(); return; }
          // /incident EXIGE titularidad verificada porque toca abonos, así que
          // devuelve 403 cuando no podemos demostrarla. /escalation es el
          // fallback que el backend mantiene justo para esto: abre el ticket
          // igualmente y lo etiqueta "sin verificar" para que el agente lo
          // compruebe. Sin este salto, el cliente que no puede verificarse se
          // queda SIN NINGÚN canal — que es como llegó aquí este bug.
          if (r.status === 403) { sendEscalation(ids); return; }
          fail();
        }).catch(fail);
    }
    // Verificación EN VIVO del pedido antes de enviar (correcciones ATC 07/08
    // y 11/08): buscamos que el ticket llegue verificado, porque así el agente
    // no tiene que comprobarlo a mano.
    //
    // Pero un 403 NO puede dejar al cliente sin canal, y eso es lo que hacía:
    // el backend responde 403 tanto si el pedido no existe como si no podemos
    // demostrar que es suyo (es un 403 uniforme A PROPÓSITO, para no ser un
    // oráculo de enumeración de pedidos), y aquí se leía siempre como «no
    // existe». Con el cliente sin sesión iniciada y sin campo de CP en el
    // formulario, ese era el caso MAYORITARIO: medido en producción sobre
    // `ayuda_public_requests`, 167 de 167 peticiones sin sesión acabaron en
    // 403 — 59 clientes distintos en 14 días, con hasta 13 reintentos sobre
    // el mismo pedido, y sin poder llegar a abrir su incidencia.
    //
    // Así que el primer 403 AVISA (por si es un dígito mal tecleado, que se
    // corrige solo) y el segundo envío sale igualmente. Se sigue intentando
    // verificar en cada intento: si el cliente corrige el dato, su ticket
    // llega verificado como antes. Un fallo de infraestructura (5xx/HTML/red)
    // no bloquea nunca, como ya hacía.
    function verifyOrderThen(cont) {
      if (v.noOrder || !on) { cont(); return; }
      fetch(API_BASE + '/lookup-order', { method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email: em, order_name: on, postal_code: pc || null }) })
        .then(function (r) {
          if ((r.status === 403 || r.status === 404) && !formCtx.verificationWarned) {
            formCtx.verificationWarned = true;
            btn.disabled = false; btn.textContent = 'Enviar de todos modos';
            statusP.textContent = pc
              ? 'No hemos podido comprobar que ese pedido sea tuyo. Revisa el número (p. ej. B2C540225), el email de la compra y el código postal de la entrega — o vuelve a pulsar Enviar y lo gestionamos igualmente.'
              : 'No hemos podido comprobar que ese pedido sea tuyo. Añade el código postal de la entrega (o inicia sesión) para que lo verifiquemos — o vuelve a pulsar Enviar y lo gestionamos igualmente.';
            return;
          }
          cont();
        })
        .catch(function () { cont(); });
    }
    // Subimos los adjuntos primero (si los hay) y enviamos SIEMPRE después,
    // aunque alguna subida falle: nunca dejamos al cliente sin salida — el
    // agente re-solicita el adjunto si hace falta.
    verifyOrderThen(function () {
      var ids = [], chain = Promise.resolve();
      files.forEach(function (f) {
        chain = chain.then(function () {
          var fd = new FormData(); fd.append('file', f);
          return fetch(API_BASE + '/upload-photo', { method: 'POST', body: fd })
            .then(function (r) { return r.ok ? r.json() : null; })
            .then(function (j) { if (j && j.photo_id) ids.push(j.photo_id); })
            .catch(function () { /* adjunto fallido: seguimos sin él */ });
        });
      });
      chain.then(function () {
        if (formCtx.kind === 'invoice') sendInvoice(ids);
        else if (formCtx.kind === 'incident') sendIncident(ids);
        else sendEscalation(ids);
      });
    });
  }

  function render() {
    view.innerHTML = '';
    QNODES = {};
    view.appendChild(renderHome(stack[0].node));
  }

  render();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.announcementBar = document.querySelector('.announcement-bar-section');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        document.body.classList.add('visible-header');
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
      document.documentElement.style.setProperty('--header-bar-height', `${this.announcementBar.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        document.body.classList.add('body-scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        document.body.classList.add('body-scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        document.body.classList.remove('body-scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      document.body.classList.remove('visible-header');
      // `popup` y `backdrop` eran globals definidas en un script
      // inline antiguo que ya no existe. Antes lanzaba ReferenceError
      // en cada scroll-down. Guardamos con typeof para no romper si
      // alguien los reintroduce, y siendo no-op cuando no estan.
      if (typeof popup !== 'undefined' && popup && popup.style && popup.style.display === 'block') {
        popup.style.display = 'none';
        if (typeof backdrop !== 'undefined' && backdrop && backdrop.style) {
          backdrop.style.display = 'none';
        }
      }
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
      document.body.classList.add('visible-header');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
      document.body.classList.remove('visible-header');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      // En scroll temprano (Samsung Internet) el <details-modal> puede existir
      // en el DOM pero aún no estar upgraded como custom element, por lo que
      // `.close` todavía no es función (Sentry SHOPIFY-2A). Guardamos.
      if (this.searchModal && typeof this.searchModal.close === 'function') {
        this.searchModal.close(false);
      }
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
